export var giftcardBreadcrumbs = [{
  title: 'Shoes & Accessories',
  url: '/collections/shoes'
}];
export var kitBreadcrumbs = [{
  title: 'OV Kits',
  url: '/collections/ov-kits'
}];
export var shopBreadcrumbs = [{
  title: 'Our Shops',
  url: '/pages/visit-us'
}];